<script>
    export default {
        name: "widgets-actions",
        props: {
            mode: String,
            manageWidgetsPrivilege: Boolean,
            displayDeleteButton: Boolean,
            superadminPrivilege: Boolean,
        },
        computed: {
            iconClass() {
                if (this.mode === 'tiles') return 'fa-sharp fa-solid fa-grid fa-lg fa-fw';
                else return 'fa-regular fa-list fa-lg';
            },
            translations() {
                return {
                    add: Lang.langGet('Add widget to current project'),
                    addToAll: Lang.langGet("Add widget to ALL projects"),
                    delete: Lang.langGet('Delete selected widget(s)'),
                    disableAll: Lang.langGet('Toggle hide for selected widget(s)')
                }
            }
        }
    }
</script>

<template>
    <div class="d-flex mb-4">
        <div class="ml-2">
            <v-btn aria-label="switch mode" @click="$emit('click')">
                <i :class="iconClass"/>
            </v-btn>
        </div>
        <div class="ml-2" v-if="manageWidgetsPrivilege">
            <v-btn aria-label="add widget" color="primary" @click="$emit('add', 0)">
                <i class="mr-1 fa-regular fa-plus fa-lg"/>
                {{translations.add}}
            </v-btn>
        </div>
        <div class="ml-2" v-if="superadminPrivilege">
            <v-btn @click="$emit('add', 1)">
                <i class="mr-1 fa-regular fa-plus fa-lg"/>
                {{ translations.addToAll }}
            </v-btn>
        </div>
        <div class="ml-2" v-if="manageWidgetsPrivilege && displayDeleteButton">
            <v-btn aria-label="delete" @click="$emit('delete')">
                <i class="mr-1 fa-regular fa-trash fa-lg"/>
                {{translations.delete}}
            </v-btn>
        </div>
        <div class="ml-2" v-if="manageWidgetsPrivilege && displayDeleteButton">
            <v-btn aria-label="disable" @click="$emit('disable')">
                <i class="mr-1 fa-regular fa-eye-slash fa-lg"/>
                {{translations.disableAll}}
            </v-btn>
        </div>
    </div>
</template>
